<template>
	<div class="aboutcom">
		<div class="comtop">
			<img src="../../static/img/salfout.png"/>
		</div>
		<div class="com-detail">
			<div class="com-top-top">
				<h4>留言反馈</h4>
				<div class="com-line">
				</div>
				
			</div>
            <div class="cominfo">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				  <el-form-item label="用户昵称" prop="name">
				    <el-input v-model="ruleForm.name"></el-input>
				  </el-form-item>
				  <el-form-item label="用户手机" prop="mob">
				    <el-input v-model="ruleForm.mob"></el-input>
				  </el-form-item>
				  <el-form-item label="用户邮箱" prop="email">
				    <el-input v-model="ruleForm.email"></el-input>
				  </el-form-item>
				  <el-form-item label="反馈内容" prop="desc">
				    <el-input type="textarea" v-model="ruleForm.desc" rows = '8'></el-input>
				  </el-form-item>
				  <el-form-item>
				    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
				    <el-button @click="resetForm('ruleForm')">重置</el-button>
				  </el-form-item>
				</el-form>
            </div>
            
		</div>
	</div>
</template>

<script>
	export default{
		name : 'aboutcom',
		data(){
			return {
				top : [
				{id : 0 , imgsrc : 'static/img/aboutcom.jpg' , title : '关于我们'},
				],
				chalid : 0,
				comimg : [
				{id :　0　, imgsrc : 'static/img/comabout1.jpg'},
				{id :　1　, imgsrc : 'static/img/comabout2.jpg'},
				],
				ruleForm: {
			          name: '',
			          mob : '',
			          email : '',
			          desc: ''
			        },
			    rules: {
		          name: [
		            { required: true, message: '请输入用户名', trigger: 'blur' },
		            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
		          ],
		          mob :[
		          	{ required: true, message: '请输入手机号', trigger: 'blur' },
		            { min: 10, max: 12, message: '长度在 11 个数字', trigger: 'blur' }
		          ],
		          email :[
		          	{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
		            { min: 5,  message: '请输入正确邮箱地址', trigger: 'blur' }
		          ],
		          desc: [
		            { required: true, message: '请填写反馈内容', trigger: 'blur' }
		          ]
		        },
				scrollWatch: true
			}
		},
		mounted(){
			this.getID();
		},
		methods : {
			submitForm(formName) {
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		            this.$http.post('http://www.gd-sc.net:9094/adddate',{content : this.ruleForm.desc , type : '留言反馈' ,creator : this.ruleForm.name ,title : this.ruleForm.mob ,table:'contentall'},{emulateJSON: true}).then((response) => {
     					alert('提交成功')
     				});
		          } else {
		            console.log('error submit!!');
		            return false;
		          }
		        });
		      },
			getID(){
				this.chalid = this.$route.params.ID
			},
			resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		},
	}
</script>

<style>
	.aboutcom{
		position: relative;
		clear: both;
		width: 100%;
		margin: 0 auto;
	}
	.comtop{
		position: relative;
		width: 100%;
		clear: both;
	}
	.comtop img{
		width: 100%;
	}
	.com-detail{
		width: 80%;
		margin: 60px auto;
		position: relative;
		clear: both;
		text-align: left;
	}
	.com-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}
	.com-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #e01313;
		border-radius: 4px;
		top: 8px;
	}
	.com-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}
	.com-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 0 auto;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
	}
	.cominfo{
		position: relative;
		clear: both;
		padding: 2%;
		text-align: center;
	}
	.cominfo p{
		color: #666666;
		line-height: 35px;
		margin: 30px auto;
		font-size: 18px;
		text-indent:2em;
		
	}
	.el-form-item__label{
		font-size: 18px !important;
	}
	.cominfo img{
		text-align: center;
	}
	..el-form-item__content{
		text-align: center;
	}
	.imgcomab{
		width: 49%;
		position: relative;
		clear: both;
		display: inline-block;
		vertical-align: top;
		text-align: center;
	}
	.imgcomab img{
		width: 85%;
	}
	.singleimg,.singlewimg{
		width:100%;
		position: relative;
		margin: 0 auto;
		text-align: center;
	}
	.com-titr{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    right: 0vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-titr img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-titr p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-titr b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.singleimg img{
		width: 75%;
	}
	.singlewimg img{
		width: 100%;
	}
	.comwenhua h3{
		color: #e03500;
		font-weight: 900;
		font-size: 22px;
	}
	.comwenhua p{
		text-indent:.5em;
	}
	.comwenhua span{
		color: #e03500;
	}
	.comwenhua{
		position: relative;
		margin-top: 45px;	
	}
	.wencom{
		position: relative;
		margin-top: 10px;
	}
	.honor{
		position: relative;
		width: 25%;
		clear: both;
		display: inline-block;
		margin: 20px auto;
		text-align: center;
	}
	.honor img{
		width: 85%;
   		height: 192px;
   		transition: .5s all;
	}
	.honor img:hover{
		transform: scale(1.1);
	}
</style>


// WEBPACK FOOTER //
// src/components/feedback.vue